import type { JdStatus } from '../types'

const CLASS: Record<JdStatus, string> = {
  Published: 'pill--published',
  'In review': 'pill--review',
  Draft: 'pill--draft',
}

/** The word is always present, so colour is never the only signal. */
export function StatusPill({ status }: { status: JdStatus }) {
  return <span className={`pill ${CLASS[status] ?? 'pill--draft'}`}>{status}</span>
}

const REQ_CLASS = {
  pending: 'pill--pending',
  approved: 'pill--approved',
  rejected: 'pill--rejected',
} as const

const REQ_LABEL = {
  pending: 'Pending with HR',
  approved: 'Approved',
  rejected: 'Declined',
} as const

export function RequestPill({ status }: { status: 'pending' | 'approved' | 'rejected' }) {
  return <span className={`pill ${REQ_CLASS[status]}`}>{REQ_LABEL[status]}</span>
}
